export default __webpack_public_path__ + "static/media/gallery_15.503db67a.jpg";